import type { FunctionComponent } from 'react';
import { paletteHelper, spacingHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { DialogModal } from '../../../../../../../app-kit/components/DialogModal/DialogModal';

interface SchoolFactsDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

const BoldBodyText = styled(Text)`
  ${typographyHelper('body01Bold')};
  color: ${paletteHelper('textSecondary')};
  padding-bottom: ${spacingHelper('large')};
`;

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

const BodyTextExtraPadding = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
  padding-top: ${spacingHelper('large')};
`;

export const SchoolFactsDisclaimer: FunctionComponent<SchoolFactsDisclaimerProps> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="School facts"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      gap="0"
    >
      <BoldBodyText>Grade acronyms:</BoldBodyText>
      <BodyText>P = Preschool</BodyText>
      <BodyText>K = Kindergarten</BodyText>
      <BodyText>Prep = Preparatory</BodyText>
      <BodyText>R = Reception</BodyText>
      <BodyText>PP = Pre-primary</BodyText>
      <BodyText>T = Transition</BodyText>
      <BodyTextExtraPadding>
        Data sourced from the Australian Curriculum, Assessment and Reporting Authority (ACARA)
        under license. Property.com.au makes no representations or warranties regarding the accuracy
        of this data. Please check with the school for the latest information.
      </BodyTextExtraPadding>
    </DialogModal>
  );
};
